// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"c19d9a05","135":"8aa1ba7e","271":"bf8faf0f","301":"3b24f179","386":"dd243003","387":"af25b47f","400":"cfd9c7ca","798":"b839a30f","968":"b7b7c9ad"}[chunkId] + ".chunk.js";
};